/** @var { LoadingStateState } */
const STATE = {
    data: null,
    isLoading: false,
};

export default STATE;
